import * as React from 'react';

import { withIntl, IntlProps } from 'ha/i18n';
import Track from 'ha/components/track/SmartTrack';
import Button from 'ha/ui/next/Button';
import Link from 'ha/ui/next/Link';
import { HOME } from 'ha/constants/pageNames';
import withCurrentPageName, {
  PageNameProps,
} from 'ha/helpers/withCurrentPageName';

interface Props {
  isVerified: boolean;
  isMobile?: boolean;
  isAuthenticated: boolean;
}

export const ListYourPlaceCTA: React.SFC<Props & IntlProps & PageNameProps> = ({
  isVerified,
  isMobile,
  isAuthenticated,
  intl: { T, urlResolver },
  pageName,
}) => {
  const mobileLinkLabel = T('submit_room_mobile');
  const desktopLinkLabel = isVerified ? T('Add Listing') : T('I am a landlord');
  const linkLabel = isMobile ? mobileLinkLabel : desktopLinkLabel;
  const isHomePage = HOME === pageName;

  return (
    <Track name="Clicked List your place in header" type="button">
      <Link
        to={
          isAuthenticated
            ? urlResolver.getListYourPlaceUrl()
            : urlResolver.getBecomeAnAdvertiserUrl()
        }
        kind="muted"
        rel={!isHomePage ? 'nofollow' : undefined}
      >
        <Button
          variant="raised"
          color="primary"
          data-test-locator="List Your Place CTA"
        >
          {linkLabel}
        </Button>
      </Link>
    </Track>
  );
};

export default withCurrentPageName(withIntl(ListYourPlaceCTA));
